export default __webpack_public_path__ + "static/media/014-windmill.91545db5.svg";